import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";

const markCodRefused = async (orderId, token) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_SERVER_URL}/order/orders/${orderId}/cod-refused`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const useMarkCodRefused = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation((orderId) => markCodRefused(orderId, token), {
    onSuccess: () => {
      queryClient.invalidateQueries("merchantOrders");
      queryClient.invalidateQueries("allOrders");
    },
  });
};

export default useMarkCodRefused;
